import { useState } from 'react';
import { Eye, EyeOff, Lock, Mail, ShieldCheck, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import axiosClient from '../api/axiosClient';
import { saveSession } from '../utils/auth';
import '../styles/login.css';

export default function LoginPage() {
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleLogin = async (event) => {
    event.preventDefault();

    if (!email.trim() || !password.trim()) {
      setErrorMessage('Veuillez saisir votre email et votre mot de passe.');
      return;
    }

    try {
      setLoading(true);
      setErrorMessage('');

      const response = await axiosClient.post('/login', {
        email: email.trim(),
        password,
      });

      const token =
        response.data?.access_token ||
        response.data?.token ||
        response.data?.data?.access_token ||
        response.data?.data?.token ||
        null;

      const user =
        response.data?.user ||
        response.data?.data?.user ||
        null;

      if (!token || typeof token !== 'string') {
        setErrorMessage('Le backend ne renvoie pas un token valide.');
        return;
      }



      saveSession(token, user);
   navigate('/dashboard', { replace: true });
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        'Email ou mot de passe incorrect.';

      setErrorMessage(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-screen">
      <div className="login-shape login-shape-yellow" />
      <div className="login-shape login-shape-green" />
      <div className="login-shape login-shape-pink" />
      <div className="login-shape login-shape-blue" />

      <main className="login-content">
        <section className="login-brand">
          <div className="login-logo-card">
  <img
    src="/assets/logo.png"
    alt="Tunisie Telecom"
    className="login-logo-img"
  />
</div>
          <p className="login-brand-name">Tunisie Telecom</p>
        </section>

        <section className="login-card">
          <h1>Connexion</h1>
          <p className="login-subtitle">
            Accédez à votre espace client de consultation
          </p>

          {errorMessage && (
            <div className="login-error">
              {errorMessage}
            </div>
          )}

          <form onSubmit={handleLogin}>
            <div className="login-input-group">
              <label>Adresse email</label>

              <div className="login-input-box">
                <Mail size={21} color="#00A88E" />
                <input
                  type="email"
                  placeholder="exemple@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="email"
                />
              </div>
            </div>

            <div className="login-input-group">
              <label>Mot de passe</label>

              <div className="login-input-box">
                <Lock size={21} color="#00A88E" />
                <input
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Votre mot de passe"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="current-password"
                />

                <button
                  type="button"
                  className="login-eye-button"
                  onClick={() => setShowPassword((prev) => !prev)}
                  aria-label="Afficher ou masquer le mot de passe"
                >
                  {showPassword ? (
                    <EyeOff size={22} color="#62716D" />
                  ) : (
                    <Eye size={22} color="#62716D" />
                  )}
                </button>
              </div>
            </div>

            <button
              type="submit"
              className="login-button"
              disabled={loading}
            >
              {loading ? (
                <span className="login-loader" />
              ) : (
                <>
                  <span>Se connecter</span>
                  <ArrowRight size={21} />
                </>
              )}
            </button>
          </form>

          <div className="login-secure">
            <ShieldCheck size={18} color="#00A88E" />
            <span>Connexion sécurisée</span>
          </div>
        </section>

        <p className="login-footer">
          © Tunisie Telecom 
        </p>
      </main>
    </div>
  );
}